import React from 'react';
import styles from './StaffDelete.module.scss';

import { IoTrashOutline } from 'react-icons/io5';
import api from '../../../helpers/api';
import { $t } from '../../../helpers/translator';
import Modal from '../../miscellaneous/Modal/Modal';


class StaffDelete extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    presentApprovalModal() {
        this.setState({ showModal: true }, () => {
            // console.log('...', this.state)
        });
    }

    closeModals() {
        this.setState({ showModal: false });
    }

    async deleteStaff() {
        try {
            // let res = await api.deleteStaff(Number(this.props.id));
            let res = await api.delete(`/staff/${this.props.id}`);
            if (res) {
                // console.log('SUCCESS DEL')
                this.setState({showModal: false})
                this.props.onSuccess({success: true})
            }
        } catch (e) {
            console.error('err deleting:', e)
        }
    }

    renderModalContent() {
        return (
            <div className={`${styles['delete-container']}`}>
                <div className={`${styles['first-row']}`}>
                    {$t('global.staff.confirmDelete')}
                </div>
                <div className={`${styles['second-row']}`}>
                    { this.props.patientId ?
                        <div>
                            <span style={{fontWeight: '300'}}>{$t('global.staff.staffId')}:</span> {this.props.patientId}
                        </div>
                        :
                        null
                    }
                    { this.props.patientName ?
                        <div>
                            <span style={{fontWeight: '300'}}>{$t('global.staff.staffName')}:</span> {this.props.patientName}
                        </div>
                        :
                        null
                    }
                </div>

                <div className={`${styles['third-row']}`}>
                    {$t('global.staff.deletionIsPermanent')}
                </div>
                <div className={`${styles['delete-approve']}`} onClick={() => this.deleteStaff()}>
                    <div className={`alma-button`}>{$t('global.staff.delete')}</div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className={`${styles['container']}`} style={this.props.style ? this.props.style : null}>
                <IoTrashOutline className={`${styles['icon']}`} onClick={() => this.presentApprovalModal()}/>

                <Modal content={this.renderModalContent()}
                       onClose={this.closeModals.bind(this)}
                       visible={this.state.showModal} />

            </div>
        );
    }
}

export default StaffDelete;
